import { useEffect, useState } from 'react';
import { requestTestAvailability } from '../services/trialRegistration';

// endpoint.php > getTrialDurationHours ile ayni beyaz liste.
const ALLOWED_HOURS = [1, 2, 3];
export const DEFAULT_TRIAL_HOURS = 3;

/**
 * Yeni acilan test hesaplarinin suresini (saat) dondurur.
 * Kaynak: sistem_ayarlari > test_suresi_saat (check_test_yayini_durumu ucundan).
 * Sunucuya ulasilamazsa veya deger beklenmedikse 3 saate duser.
 */
export default function useTrialHours() {
  const [hours, setHours] = useState(DEFAULT_TRIAL_HOURS);

  useEffect(() => {
    let active = true;
    requestTestAvailability()
      .then((result) => {
        const value = Number(result?.data?.test_suresi_saat);
        if (active && ALLOWED_HOURS.includes(value)) setHours(value);
      })
      .catch(() => {
        // Sessiz gec: varsayilan 3 saat kalir.
      });
    return () => { active = false; };
  }, []);

  return hours;
}
